import React, { createContext, useContext, useEffect, useState } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const DEFAULT_CONFIG = {
  stats: {
    loads_washed: 0,
    children_supported: 0,
    families_helped: 0,
    volunteer_hours: 0,
  },
  contact: {
    email: "Ccdkofhamilton@outlook.com",
    phone: "(513) 000-0000",
    address: "Hamilton, Ohio",
    hours: "Tue – Sat • 9:00 AM – 6:00 PM",
    donate_url: "https://venmo.com/u/ccdkofhamilton",
  },
  hero_images: ["", "", ""],
  stories: [],
};

const SiteContext = createContext({ config: DEFAULT_CONFIG, loading: true });

export function SiteProvider({ children }) {
  const [config, setConfig] = useState(DEFAULT_CONFIG);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    axios
      .get(`${API}/site`)
      .then((res) => {
        if (active) setConfig({ ...DEFAULT_CONFIG, ...res.data });
      })
      .catch(() => {})
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  return (
    <SiteContext.Provider value={{ config, loading, setConfig }}>
      {children}
    </SiteContext.Provider>
  );
}

export const useSite = () => useContext(SiteContext);
